import {
  Button,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  Text
} from 'mailup-web-components'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'

import { canUseMshop, mshopBuy } from 'Helpers/mshopHelpers'

const ModalOfferLightUpsell = ({ show, onClose }) => {
  const intl = useIntl()

  return (
    <Modal
      show={show}
      showClose
      closeOnOverlayClick
      onClose={onClose}
      data-mu-test='modal-offer-light-upsell'
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.BaseConfigUpsell.ModalTemplatesLimitsTitle'
        })}
      />
      <ModalBody>
        {intl.formatMessage(
          {
            id: 'Load.BaseConfigUpsell.ModalTemplatesLimitsDescription'
          },
          {
            linebreak: <br />
          }
        )}
      </ModalBody>
      <ModalFoot>
        {canUseMshop ? (
          <Button kind='primary' onClick={mshopBuy}>
            {intl.formatMessage({
              id: 'Load.BaseConfigUpsell.ModalTemplatesLimitsCTA'
            })}
          </Button>
        ) : (
          <Text>
            {intl.formatMessage({
              id: 'Load.BaseConfigUpsell.ModalTemplatesLimitsAskBuy'
            })}
          </Text>
        )}
      </ModalFoot>
    </Modal>
  )
}

ModalOfferLightUpsell.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
}

export default ModalOfferLightUpsell
